import request from '@ps/utils/request'

export function cropFont(data: { pid: number; font: string; text: string }) {
  return request({
    url: '/ps/editor/font/crop',
    method: 'post',
    data,
  })
}
